export default __webpack_public_path__ + "static/blog-post-7-1e39cccbb66e999813864a893ead5c69.png";